import ModalBackdrop from '../ModalBackdrop'

interface LeaveLeagueConfirmProps {
  // The owner deletes the league for everyone; a member only leaves their own membership.
  isOwner: boolean
  onConfirm: () => void
  onClose: () => void
}

function LeaveLeagueConfirm({
  isOwner,
  onConfirm,
  onClose,
}: LeaveLeagueConfirmProps) {
  return (
    <ModalBackdrop onClose={onClose}>
      <div className="league-detail__confirm">
        <p className="league-detail__confirm-title">
          {isOwner ? 'Delete this league?' : 'Leave this league?'}
        </p>
        <p className="league-detail__confirm-body">
          {isOwner
            ? 'This deletes the league for everyone. This cannot be undone.'
            : 'You can rejoin later with an invite code.'}
        </p>
        <div className="league-detail__confirm-actions">
          <button
            className="league-detail__confirm-cancel"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="league-detail__confirm-danger"
            onClick={onConfirm}
          >
            {isOwner ? 'Delete' : 'Leave'}
          </button>
        </div>
      </div>
    </ModalBackdrop>
  )
}

export default LeaveLeagueConfirm
